<script>
import { mapGetters, mapState } from 'vuex'
export default {
  methods: {
    goto (route) {
      if (route.name && route.name === this.$route.name) return
      this.$router.push(route)
    }
  },
  computed: {
    ...mapState({
      administrator: state => state.companies.administrator,
      selectedCompany: state => state.companies.selectedCompany,
      selectedApp: state => state.apps.selectedApp,
      userKeybe: state => state.auth.userKeybe
    }),
    ...mapGetters([
      'administratorRoles',
      'isAdmin',
      'isSuperAdmin',
      'userType',
      'businessModule'
    ]),
    isCloudTask () {
      return this.$store.state.auth.isCloudTask
    },
    sideBarItems () {
      const selectedAppUuid = this.selectedApp.UUID
      const selectedCompanyUuid = this.selectedCompany.UUID
      const isKeybeApp = selectedAppUuid === 'bisovsddqjmtl2w5k'
      const vue = this
      return [
        // Super Admin module
        {
          name: this.$t('sidebar.superDesktop'),
          icon: { name: 'mdi-trending-up', color: 'kbGold', size: '36px' },
          shownCondition: this.isSuperAdmin,
          itemFunction () {
            vue.goto({ name: 'Superuser Home' })
          },
          pathName: 'Superuser Home'
        },
        // Home module
        {
          name: this.$t('sidebar.panel'),
          icon: { color: 'kbSemiDarkBlue' },
          image: {
            src:
              'https://storage.googleapis.com/keybe/dashboard-icons/home-blue.svg',
            srcCloudtask:
              'https://storage.googleapis.com/keybe/dashboard-icons/home-ct.svg',
            srcWhite:
              'https://storage.googleapis.com/keybe/dashboard-icons/home-white.svg',
            alt: 'Home icon',
            size: '32px'
          },
          shownCondition: true,
          itemFunction () {
            vue.goto({ name: 'Home' })
          },
          pathName: 'Home'
        },
        // People's module
        {
          name: this.$t('sidebar.directory'),
          icon: { name: 'mdi-fingerprint', color: 'kbPink', size: '38px' },
          isSubItemSelected () {
            const subItemsRouteNames = [
              'PeopleDirectory',
              'Negocios',
              'Opportunities',
              'Lists Persons'
              // 'Formularios',
              // 'Keybe UI'
            ]
            return subItemsRouteNames.includes(vue.$route.name)
          },
          shownCondition: selectedAppUuid,
          subItemsValue: 'people',
          subItems: [
            {
              name: this.$t('sidebar.people'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'PeopleDirectory',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'PeopleDirectory'
            },
            {
              name: this.businessModule.p,
              shownCondition: this.sidebarModules.includes('sidebar-business'),
              itemFunction () {
                vue.goto({
                  name: 'Negocios',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Negocios'
            },
            /* TODO - MAKE OPPORTUNITY COMPONENT */
            {
              name: this.$t('sidebar.opportunities'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Opportunities',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Opportunities'
            },
            {
              name: this.$t('sidebar.lists'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Lists Persons',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Lists Persons'
            }
            // {
            //   name: this.$t('sidebar.forms'),
            //   shownCondition:
            //     selectedAppUuid &&
            //     (this.isSuperAdmin ||
            //       this.isAdmin ||
            //       this.administratorRoles.includes('ROLE_FORMS')),
            //   itemFunction() {
            //     vue.goto({
            //       name: 'Formularios',
            //       params: { appid: selectedAppUuid }
            //     });
            //   },
            //   pathName: 'Formularios'
            // },
            // {
            //   name: this.$t('sidebar.authenticator'),
            //   shownCondition: true,
            //   itemFunction() {
            //     vue.goto({ name: 'Keybe UI' });
            //   },
            //   pathName: 'Keybe UI'
            // }
            /* {
              name: this.$t('sidebar.segments'),
              shownCondition: selectedAppUuid && isKeybeApp,
              itemFunction () {}
            } */
          ]
        },
        // Sequences module
        {
          name: this.$t('sidebar.reachFrequency'),
          icon: { name: 'mdi-file-tree', color: 'kbPink', size: '32px' },
          isSubItemSelected () {
            const subItemsRouteNames = [
              'Sequences',
              'Sequences Schedules',
              'Sequences actions'
            ]
            return subItemsRouteNames.includes(vue.$route.name)
          },
          shownCondition: selectedAppUuid,
          subItemsValue: 'sequences',
          subItems: [
            {
              name: this.$t('sidebar.sequences'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Sequences',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Sequences'
            },
            {
              name: this.$t('general.rules'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Sequences rules',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Sequences rules'
            },
            {
              name: this.$t('general.schedules'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Sequences Schedules',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Sequences Schedules'
            }
          ]
        },
        // Conversations module
        {
          name: this.$t('sidebar.talk'),
          icon: { color: 'kbGreen' },
          image: {
            src: 'https://storage.googleapis.com/keybe/cloudtask/conversa2.svg',
            srcCloudtask:
              'https://storage.googleapis.com/keybe/dashboard-icons/conversa-ct.svg',
            srcWhite:
              'https://storage.googleapis.com/keybe/cloudtask/conversa2-blanco.svg',
            alt: 'conversa icon',
            size: '32px'
          },
          shownCondition:
            selectedAppUuid &&
            (this.isAdmin ||
              this.isSuperAdmin ||
              this.administratorRoles.includes('ROLE_CONVERSATIONS') ||
              this.sidebarModules.includes('sidebar-conversations')),
          itemFunction () {
            vue.goto({ name: 'Conversaciones' })
          },
          pathName: 'Conversaciones'
        },
        // Communications module
        {
          name: this.$t('sidebar.communicate'),
          icon: { color: 'kbLightBlue' },
          image: {
            src:
              'https://storage.googleapis.com/keybe/dashboard-icons/ejecuta.svg',
            srcCloudtask:
              'https://storage.googleapis.com/keybe/dashboard-icons/ejecuta-ct.svg',
            srcWhite:
              'https://storage.googleapis.com/keybe/dashboard-icons/ejecuta-blanco.svg',
            alt: 'Automate icon',
            size: '36px'
          },
          isSubItemSelected () {
            const subItemsRouteNames = ['Campaigns', 'Formularios', 'Keybe UI']
            return subItemsRouteNames.includes(vue.$route.name)
          },
          shownCondition: selectedAppUuid,
          subItemsValue: 'campaigns',
          subItems: [
            {
              name: this.$t('sidebar.communicate'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Campaigns',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Campaigns'
            },
            {
              name: this.$t('sidebar.forms'),
              shownCondition:
                selectedAppUuid &&
                (this.isSuperAdmin ||
                  this.isAdmin ||
                  this.administratorRoles.includes('ROLE_FORMS')),
              itemFunction () {
                vue.goto({
                  name: 'Formularios',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Formularios'
            },
            {
              name: this.$t('sidebar.authenticator'),
              shownCondition: true,
              itemFunction () {
                vue.goto({ name: 'Keybe UI' })
              },
              pathName: 'Keybe UI'
            }
          ]
        },
        /* {
              name: this.$t('sidebar.notifications'),
              shownCondition: selectedAppUuid,
              itemFunction () { vue.goto({ name: 'Notifications', params: { appid: selectedAppUuid } }) },
              pathName: 'Notifications'
            } */
        // {
        //   name: this.$t('sidebar.automate'),
        //   icon: { color: 'kbPurple' },
        //   image: {
        //     src: 'https://storage.googleapis.com/keybe/dashboard-icons/aprende.svg',
        //     srcCloudtask: 'https://storage.googleapis.com/keybe/dashboard-icons/aprende-ct.svg',
        //     srcWhite: 'https://storage.googleapis.com/keybe/dashboard-icons/aprende-blanco.svg',
        //     alt: 'Automate icon',
        //     size: '30px'
        //   },
        //   shownCondition: selectedAppUuid,
        //   itemFunction () { vue.goto({ name: 'Disparadores', params: { appid: selectedAppUuid } }) },
        //   pathName: 'Disparadores'
        // },
        // Events module
        {
          name: this.$t('sidebar.events'),
          icon: { name: 'mdi-ticket', color: 'kbGold' },
          isSubItemSelected () {
            const subItemsRouteNames = [
              'Eventos',
              'Places',
              'Categories',
              'Asistentes',
              'Promotors',
              'Djs',
              'Products',
              'ProductsSales'
            ]
            return subItemsRouteNames.includes(vue.$route.name)
          },
          shownCondition:
            selectedAppUuid &&
            ((isKeybeApp && process.env.NODE_ENV !== 'production') ||
            selectedAppUuid === 'bisovs8kwjtk8iyxi' || // MedellinStyle
            selectedAppUuid === '4xqaosvkamm5sm4' || // Kb.live
              selectedAppUuid === '4xqap8nkkgzshvo') && // Breakfastclub
            (this.isAdmin ||
              this.isSuperAdmin ||
              this.administratorRoles.includes('ROLE_EVENTS')),
          subItemsValue: 'events',
          subItems: [
            {
              name: this.$t('sidebar.myEvents'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Eventos',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Eventos'
            },
            {
              name: this.$t('sidebar.places'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'Places',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Places'
            },
            {
              name: this.$t('sidebar.categories'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Categories',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Categories'
            },
            {
              name: this.$t('sidebar.assistants'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Asistentes',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Asistentes'
            },
            {
              name: this.$t('sidebar.promotors'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Promotors',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Promotors'
            },
            {
              name: this.$t('sidebar.djs'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({ name: 'Djs', params: { appid: selectedAppUuid } })
              },
              pathName: 'Djs'
            },
            {
              name: this.$t('sidebar.productsCategories'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'ProductsCategories',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'ProductsCategories'
            },
            {
              name: this.$t('sidebar.products'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'Products',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'Products'
            },
            {
              name: this.$t('sidebar.productsSales'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({
                  name: 'ProductsSales',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'ProductsSales'
            }
          ]
        },
        // Purchases module
        {
          name: this.$t('sidebar.purchases'),
          icon: { name: 'feather-shopping-cart', color: 'kbGold' },
          isSubItemSelected () {
            const subItemsRouteNames = ['OrderPurchases', 'OrderProducts']
            return subItemsRouteNames.includes(vue.$route.name)
          },
          shownCondition:
            selectedAppUuid && selectedAppUuid === '23bah3gkbhxht1u',
          subItemsValue: 'orders',
          subItems: [
            {
              name: this.$t('sidebar.purchases'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'OrderPurchases',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'OrderPurchases'
            },
            {
              name: this.$t('sidebar.products'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'OrderProducts',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'OrderProducts'
            }
          ]
        },
        // Masters module
        {
          name: this.$t('sidebar.mainTables'),
          icon: { name: 'mdi-table-key', color: 'kbGold' },
          isSubItemSelected () {
            const subItemsRouteNames = [
              'OrderClients',
              'OrderColors',
              'OrderContainerTypes',
              'OrderSuppliers',
              'OrderSellers'
            ]
            return subItemsRouteNames.includes(vue.$route.name)
          },
          shownCondition:
            selectedAppUuid && selectedAppUuid === '23bah3gkbhxht1u',
          subItemsValue: 'masters',
          subItems: [
            {
              name: this.$t('sidebar.clients'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'OrderClients',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'OrderClients'
            },
            {
              name: this.$t('sidebar.colors'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'OrderColors',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'OrderColors'
            },
            {
              name: this.$t('sidebar.containerTypes'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'OrderContainerTypes',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'OrderContainerTypes'
            },
            {
              name: this.$t('sidebar.suppliers'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'OrderSuppliers',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'OrderSuppliers'
            },
            {
              name: this.$t('sidebar.sellers'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'OrderSellers',
                  params: { appid: selectedAppUuid }
                })
              },
              pathName: 'OrderSellers'
            }
          ]
        },
        // Inmobiliarias module
        {
          name: 'Inmobiliarias',
          icon: { name: 'feather-grid', color: 'kbGreen' },
          shownCondition:
            selectedAppUuid && selectedAppUuid === 'bisovs19ejr0rgc5c',
          itemFunction () {
            vue.goto({ name: 'Real Estate' })
          },
          pathName: 'Real Estate'
        },
        // emails module
        {
          name: 'Tasks',
          icon: {
            name: 'mdi-format-list-checks',
            color: 'kbBlue',
            size: '26px'
          },
          isSubItemSelected () {
            const subItemsRouteNames = ['Emails']
            return subItemsRouteNames.includes(vue.$route.name)
          },
          // shownCondition: selectedAppUuid === '4xqaa0ek80qvp1n',
          shownCondition: true,
          subItemsValue: 'todo',
          subItems: [
            {
              name: 'Emails',
              shownCondition: true,
              itemFunction () {
                vue.goto({ name: 'Emails' })
              },
              pathName: 'Emails'
            }
          ]
        },
        // Configuration module
        {
          name: this.$t('sidebar.configure'),
          icon: { name: 'feather-settings', color: 'kbBlue', size: '26px' },
          isSubItemSelected () {
            const subItemsRouteNames = [
              'Configuracion',
              'Detalles',
              'Administradores',
              'DailyUsage',
              'journey',
              'ConversationSettings',
              'Roles',
              'User Configuration'
            ]
            return subItemsRouteNames.includes(vue.$route.name)
          },
          shownCondition:
            selectedAppUuid && (this.isAdmin || this.isSuperAdmin),
          subItemsValue: 'settings',
          subItems: [
            {
              name: this.$t('sidebar.generalities'),
              shownCondition: true,
              itemFunction () {
                vue.goto({ name: 'Configuracion' })
              },
              pathName: 'Configuracion'
            },
            {
              name: this.$t('sidebar.apps'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'Detalles',
                  params: {
                    companyid: selectedCompanyUuid,
                    appid: selectedAppUuid
                  }
                })
              },
              pathName: 'Detalles'
            },
            {
              name: this.$t('sidebar.administrators'),
              shownCondition:
                selectedAppUuid && (this.isSuperAdmin || this.isAdmin),
              itemFunction () {
                vue.goto({
                  name: 'Administradores',
                  params: {
                    companyid: selectedCompanyUuid,
                    appid: selectedAppUuid
                  }
                })
              },
              pathName: 'Administradores'
            },
            // {
            //   name: this.$t('sidebar.billing'),
            //   shownCondition: true,
            //   itemFunction () { vue.goto({ name: 'DailyUsage' }) },
            //   pathName: 'DailyUsage'
            // },
            {
              name: this.$t('sidebar.conversationSettings'),
              shownCondition: true,
              itemFunction () {
                vue.goto({ name: 'ConversationSettings' })
              },
              pathName: 'ConversationSettings'
            },
            {
              name: this.$t('sidebar.emailSettings'),
              shownCondition: true,
              itemFunction () {
                vue.goto({ name: 'EmailSettings' })
              },
              pathName: 'EmailSettings'
            },
            {
              name: this.$t('sidebar.userConfiguration'),
              shownCondition: true,
              itemFunction () {
                vue.goto({ name: 'User Configuration' })
              }
            },
            {
              name: this.$t('sidebar.roles'),
              shownCondition: selectedAppUuid,
              itemFunction () {
                vue.goto({ name: 'Roles', params: { appid: selectedAppUuid } })
              },
              pathName: 'Roles'
            },
            {
              name: this.$t('general.journey'),
              shownCondition: true,
              itemFunction () {
                vue.goto({
                  name: 'journey',
                  params: {
                    appid: selectedAppUuid,
                    companyid: selectedCompanyUuid
                  }
                })
              },
              pathName: 'journey'
            }
          ]
        }
      ]
    }
  }
}
</script>
